import React from 'react';
import { EditorState, convertToRaw, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const DetailComponent = props => {

    const { title, content, CreatedDate } = props.data.find(x => x.id === props.id_ditail)
    const isEmpty = obj => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) return false;
        }
        return true;
    };
    const EditorRead = (value) => {
        if (isEmpty(value)) return null
        const content = convertFromRaw(value);
        const sdsd = EditorState.createWithContent(content);
        return (
            <div>
                <div>
                    <Editor toolbarHidden={true} editorState={sdsd} readOnly={true} />
                </div>
            </div>
        );
    }
    return (
        <div>

            <h2>{title}</h2>
            <div className="border-0 card-header">
                <div className="row">
                    <div className="col">
                        {/* <h2>{Title}</h2> */}
                    </div>
                    <div className="col-auto col">
                        <p>Ngày tạo: {CreatedDate}</p>
                    </div>
                </div>
            </div>
            {EditorRead(JSON.parse(content))}

        </div>
    );
};


export default DetailComponent;